import { useEffect, useState } from 'react';
import { useNavigate, Routes, Route } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import Sidebar from './components/Sidebar';
import AdminDashboard from './dashboard/page';
import ServicesPage from './services/page';
import BrandsPage from './brands/page';
import MessagesPage from './messages/page';
import SettingsPage from './settings/page';
import SlidersPage from './sliders/page';
import UsersPage from './users/page';
import PagesPage from './pages/page';
import MenusPage from './menus/page';
import BlogPage from './blog/page';
import MediaPage from './media/page';

export default function AdminPanel() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        navigate('/admin/login');
        return;
      }

      // Kullanıcının rolünü kontrol et
      const { data: roleData } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', user.id)
        .single();

      if (!roleData || !['admin', 'editor', 'content_manager'].includes(roleData.role)) {
        await supabase.auth.signOut();
        navigate('/admin/login');
        return;
      }

      setUser(user);
    } catch (error) {
      console.error('Auth error:', error);
      navigate('/admin/login');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/admin/login');
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-teal-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar onLogout={handleLogout} />
      
      <main className="flex-1 overflow-auto">
        <Routes>
          <Route index element={<AdminDashboard />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="menus" element={<MenusPage />} />
          <Route path="pages" element={<PagesPage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="media" element={<MediaPage />} />
          <Route path="sliders" element={<SlidersPage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route path="brands" element={<BrandsPage />} />
          <Route path="messages" element={<MessagesPage />} />
          <Route path="users" element={<UsersPage />} />
        </Routes>
      </main>
    </div>
  );
}
